export default __webpack_public_path__ + "static/media/play-store.9406057d.svg";